import { render, staticRenderFns } from "./ControlsDesktop.vue?vue&type=template&id=61d64c3c&scoped=true&"
import script from "./ControlsDesktop.vue?vue&type=script&lang=js&"
export * from "./ControlsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ControlsDesktop.vue?vue&type=style&index=0&id=61d64c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d64c3c",
  null
  
)

export default component.exports